import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Judge: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m184.08 665.77-63.64-63.64 233.35-233.34 21.21 21.21-212.13 212.13 21.21 21.22 212.13-212.14 21.22 21.22z' />
    <path d='m481.07 453.64-148.49-148.49 106.07-106.07 148.49 148.49zm-106.07-148.49 106.07 106.07 63.64-63.64-106.07-106.07z' />
    <path d='m523.49 538.49-84.85-84.85 148.49-148.49 53.03 53.03c8.5 8.5 13.18 19.8 13.18 31.82s-4.68 23.32-13.18 31.82zm-42.43-84.85 42.43 42.43 95.46-95.46c2.83-2.83 4.39-6.6 4.39-10.61s-1.56-7.77-4.39-10.61l-31.82-31.82z' />
    <path d='m332.57 347.57-84.85-84.85 148.49-148.49 53.03 53.03c17.55 17.55 17.55 46.09 0 63.64zm-42.43-84.85 42.43 42.43 95.46-95.46c5.85-5.85 5.85-15.36 0-21.21l-31.82-31.82-106.07 106.07z' />
  </IconBase>
));

Judge.displayName = 'Judge';

export default Judge;
